module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "cb-section cb-bar cb-portal-section"
  }, [_c('cb-slide-n-fade', {
    attrs: {
      "isList": true,
      "is-list": true,
      "timeOut": true,
      "reCalculateMargin": true
    }
  }, _vm._l((_vm.subscriptionsToShow), function(item, index) {
    return ((index < _vm.limit)) ? _c('div', {
      directives: [{
        name: "cb-link",
        rawName: "v-cb-link",
        value: ('shadow'),
        expression: "'shadow'"
      }],
      key: index,
      staticClass: "cb-bar__wrap",
      class: {
        'cb-bar__wrap--noborder': index == _vm.limit - 1 && _vm.subscriptionLimit && _vm.subscriptionsToShow.length >= _vm.subscriptionLimit
      },
      attrs: {
        "role": "navigation",
        "data-cb-id": "subscription_details"
      },
      on: {
        "click": function($event) {
          _vm.navigate_to('sub_details', {
            params: {
              subscriptionId: item.id
            }
          })
        }
      }
    }, [(!item.hide_plan) ? _c('div', {
      staticClass: "cb-bar__title"
    }, [(item.isGiftClaimed) ? _c('span', [_c('i', {
      staticClass: "icon-gift",
      style: (_vm.themeColor)
    })]) : _vm._e(), _vm._v(" "), (item.state == 'cancelled') ? _c('span', {
      staticClass: "cb-bar__flag"
    }, [_vm._v(_vm._s(_vm.st('subscription_status.canceled')))]) : _vm._e(), _vm._v(" "), (item.state == 'paused') ? _c('span', {
      staticClass: "cb-bar__flag"
    }, [_vm._v(_vm._s(_vm.st('subscription_status.paused')))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "cb-bar__middle"
    }, [_vm._v(_vm._s(item.plan_name))]), _vm._v(" "), (item.plan_quantity > 1) ? _c('span', {
      staticClass: "cb-bar__middle"
    }, [_vm._v("× " + _vm._s(item.plan_quantity))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.addons && item.addons.length > 0) ? _vm._l((item.addons), function(addon, index) {
      return (index < 1) ? _c('div', {
        key: index,
        staticClass: "cb-bar__title"
      }, [(item.hide_plan) ? [(item.state == 'cancelled') ? _c('span', {
        staticClass: "cb-bar__flag"
      }, [_vm._v(_vm._s(_vm.st('subscription_status.canceled')))]) : _vm._e(), _vm._v(" "), (item.state == 'paused') ? _c('span', {
        staticClass: "cb-bar__flag"
      }, [_vm._v(_vm._s(_vm.st('subscription_status.paused')))]) : _vm._e()] : _vm._e(), _vm._v("\n            " + _vm._s(addon.details.invoice_name || addon.details.name) + "\n            "), (addon.quantity > 1) ? _c('span', [_vm._v("× " + _vm._s(addon.quantity))]) : _vm._e()], 2) : _vm._e()
    }) : _vm._e(), _vm._v(" "), (item.addons && item.addons.length > 1) ? _c('div', [_vm._v("+" + _vm._s(item.addons.length - 1) + " " + _vm._s(_vm.getMoreItemTxt()))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "cb-bar__content"
    }, [(item.hide_plan && (!item.addons || item.addons.length == 0)) ? [(item.state == 'cancelled') ? _c('span', {
      staticClass: "cb-bar__flag"
    }, [_vm._v(_vm._s(_vm.st('subscription_status.canceled')))]) : _vm._e(), _vm._v(" "), (item.state == 'paused') ? _c('span', {
      staticClass: "cb-bar__flag"
    }, [_vm._v(_vm._s(_vm.st('subscription_status.paused')))]) : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.isGift(item)) ? _c('span', {
      staticClass: "cb-bar__price"
    }, [_vm._v(_vm._s(_vm._f("cbCurrency")(item.recurring_price, item.currency_code)))]) : _vm._e(), _vm._v(" "), (!_vm.isGift(item) && _vm.billingText(item)) ? _c('span', {
      staticClass: "cb-bar__desc"
    }, [_vm._v(_vm._s(_vm.billingText(item)))]) : _vm._e(), _vm._v(" "), (_vm.additionalSummaryInfo(item)) ? _c('div', {
      directives: [{
        name: "cb-html",
        rawName: "v-cb-html",
        value: (_vm.additionalSummaryInfo(item)),
        expression: "additionalSummaryInfo(item)"
      }],
      staticClass: "cb-truncate"
    }) : _vm._e(), _vm._v(" "), (_vm.isGift(item)) ? _c('span', [_vm._v(_vm._s(_vm.gifterInfo(item)))]) : _vm._e(), _vm._v(" "), (item.description && _vm.subscriptionsToShow.length == 1) ? _c('div', {
      directives: [{
        name: "cb-html",
        rawName: "v-cb-html",
        value: (_vm.sanitizeTags(item.description)),
        expression: "sanitizeTags(item.description)"
      }],
      staticClass: "cb-bar__desc"
    }) : _vm._e()], 2), _vm._v(" "), (_vm.isPaidByParent(item)) ? _c('cb-notes', {
      staticClass: "cb-mar--t-sm cb-notebar--sm cb-bar__note",
      attrs: {
        "type": "suggestion",
        "message": _vm.getPaidByParentInfo(item)
      }
    }) : _vm._e()], 2) : _vm._e()
  })), _vm._v(" "), (_vm.subscriptionLimit && _vm.subscriptionsToShow.length > _vm.subscriptionLimit) ? _c('div', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('shadow'),
      expression: "'shadow'"
    }],
    staticClass: "cb-bar__wrap cb-bar__link cb-bar__link--bt",
    attrs: {
      "role": "link",
      "data-cb-id": "load_more"
    },
    on: {
      "click": function($event) {
        _vm.navigate_to('sub_template')
      }
    }
  }, [(_vm.showNumberOfItemsMore) ? [_vm._v("+" + _vm._s(_vm.subscriptionsToShow.length - 2) + " " + _vm._s(_vm.st('more_subscriptions_txt')))] : [_vm._v(_vm._s(_vm.t('subscriptions.more')))]], 2) : _vm._e()], 1), _vm._v(" "), (this.subscriptionLimit) ? _c('div', {
    staticClass: "cb-section"
  }, [(_vm.subscriptionsToShow.length == 0 && _vm.giftedSubsDisplayList.length > 0) ? _c('div', {
    staticClass: "cb-section__wrap"
  }, [_c('div', {
    staticClass: "cb-section__title cb-section__title--xs cb-section__title--muted"
  }, [_vm._v("– " + _vm._s(_vm.t('home.gift_header')) + " –")]), _vm._v(" "), _c('gift-template', {
    attrs: {
      "giftLimit": "1"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showGiftBar) ? _c('div', {
    staticClass: "cb-bar cb-bar--dashed"
  }, [(_vm.giftedSubsDisplayList.length > 0) ? _c('div', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('shadow'),
      expression: "'shadow'"
    }],
    staticClass: "cb-bar__wrap cb-bar__muted",
    attrs: {
      "role": "link",
      "data-cb-id": "load_more"
    },
    on: {
      "click": function($event) {
        _vm.navigate_to('gift_template')
      }
    }
  }, [_c('i', {
    staticClass: "icon-gift",
    style: (_vm.themeColor)
  }), _vm._v(" "), _c('span', {
    staticClass: "cb-bar__middle"
  }, [_vm._v(_vm._s(_vm.t('home.gift_bar', {
    number: _vm.giftedSubsDisplayList.length
  })))])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (this.subscriptionLimit) ? _c('div', {
    staticClass: "cb-section"
  }, [(_vm.subscriptionsToShow.length == 0 && _vm.giftedSubsDisplayList.length == 0 && _vm.childSubDataDisplayList.length > 0) ? _c('div', {
    staticClass: "cb-section__wrap"
  }, [_c('div', {
    staticClass: "cb-section__title cb-section__title--xs cb-section__title--muted"
  }, [_vm._v("– " + _vm._s(_vm.t('home.child_sub_header') || 'Child subscriptions') + " –")]), _vm._v(" "), _c('child-sub-template', {
    attrs: {
      "childSubLimit": "1"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showChildSubBar) ? _c('div', {
    staticClass: "cb-bar cb-bar--dashed"
  }, [(_vm.childSubDataDisplayList.length > 0) ? _c('div', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('shadow'),
      expression: "'shadow'"
    }],
    staticClass: "cb-bar__wrap cb-bar__muted",
    attrs: {
      "role": "link",
      "data-cb-id": "load_more"
    },
    on: {
      "click": function($event) {
        _vm.navigate_to('child_sub_template')
      }
    }
  }, [_c('i', {
    staticClass: "icon-parent-child",
    style: (_vm.themeColor)
  }), _vm._v(" "), _c('span', {
    staticClass: "cb-bar__middle"
  }, [_vm._v("\n          " + _vm._s(_vm.getChildSubBarTxt()) + "\n        ")])]) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a3d1784"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/portal/PortalSubscriptionTemplateCommon.vue
// module id = 586
// module chunks = 66